import { OnboardingWizard } from '../../components/onboarding';

export default function MyOnboarding() {
  return (
    <div className="p-6">
      <OnboardingWizard />
    </div>
  );
}
